export default {
  "global.edit": { en: "edit", fa: "ویرایش" },
  "global.delete": { en: "Delete", fa: "حذف" },
  "global.submit": { en: "Submit", fa: "تایید" },
  "global.required": {
    en: "This field is required",
    fa: "پر کردن این فیلد الزامی است"
  },
  "global.clear": { en: "Clear", fa: "پاک‌ کردن" },
  "global.cancel": { en: "Cancel", fa: "لغو" },
  "global.not-supported": {
    en: "Not Supported Yet !",
    fa: "در حال حاضر پشتیبانی نمیشود !"
  },
  "global.en": { en: "English", fa: "انگلیسی" },
  "global.fa": { en: "Farsi", fa: "فارسی" },
  "global.translations": { en: "Translations", fa: "ترجمه‌ها" },
  "global.delete-question": {
    en: "Do you want to delete?",
    fa: "آیا مایل به حذف هستید؟"
  },
  "global.yes": { en: "Yes", fa: "بله" },
  "global.no": { en: "No", fa: "خیر" }
};
